<ion-content [fullscreen]="true">
  <div id="mapId" ></div>
</ion-content>
